import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
    FormControl,
    IconButton,
    Input,
    InputAdornment,
    InputLabel,
    Typography,
} from "@mui/material";
import React from "react";

const PasswordInput = ({ label, setData, data }) => {
    const [showPassword, setShowPassword] = React.useState(false);
    const [errorPasswordLength, setErrorPasswordLength] = React.useState(false);
    const [errorPasswordMessage, setErrorPasswordMessage] = React.useState("");

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    return (
        <FormControl variant="standard" fullWidth margin="dense" required>
            <InputLabel>{label}</InputLabel>
            <Input
                inputProps={{
                    autoComplete: "new-password",
                }}
                fullWidth
                type={showPassword ? "text" : "password"}
                onChange={(evt) => {
                    if (
                        evt.target.value.length < 8 ||
                        evt.target.value.length > 16
                    ) {
                        setErrorPasswordMessage(
                            "La contraseña debe tener entre 8 y 16 caracteres"
                        );
                        setErrorPasswordLength(true);
                    } else {
                        setErrorPasswordLength(false);
                    }
                    setData({
                        ...data,
                        password: evt.target.value,
                    });
                }}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label={showPassword ? "Ocultar" : "Ver"}
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            onMouseUp={handleMouseUpPassword}
                            edge="end"
                        >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                }
            />
            {errorPasswordLength && (
                <Typography variant="caption" color="error">
                    {errorPasswordMessage}
                </Typography>
            )}
        </FormControl>
    );
};

export default PasswordInput;
